function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu:_Sent_Homeworks",
  "data-name": "Menu: Sent Homeworks"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.732,26.45a1.751,1.751,0,0,1-1.106-.393l-4.061-3.188-2.673,2.088a1.744,1.744,0,0,1-1.113.38,1.766,1.766,0,0,1-1.752-1.781V18.528L4.938,12.944a1.76,1.76,0,0,1-.587-.809A.967.967,0,0,1,4.312,12,1.77,1.77,0,0,1,5.458,9.865L34.668.091a1.8,1.8,0,0,1,1.917.536c.017.02.033.04.048.061a1.9,1.9,0,0,1,.2,1.885L24.287,25.537a1.035,1.035,0,0,1-.12.174l0,0a.633.633,0,0,1-.119.151,1.758,1.758,0,0,1-1.131.581A1.711,1.711,0,0,1,22.732,26.45Zm.137-1.96,0,0Zm-5.3-3.891a1,1,0,0,1,.618.213l4.482,3.519L34.785,2.16,6.5,11.626l7.149,5.632a1,1,0,0,1,.381.785V23.1l2.924-2.284A1,1,0,0,1,17.567,20.6Zm-3.54,2.964v0Zm-.376-.174-.012.009ZM6.162,11.363l0,0Z",
  transform: "translate(0 -0.004)",
  fill: "#626a84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.008,19.044a1,1,0,0,1-.593-1.806L35.235.471a1,1,0,1,1,1.184,1.612L13.6,18.85A1,1,0,0,1,13.008,19.044Z",
  transform: "translate(0 -0.004)",
  fill: "#626a84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.546,22.6a1,1,0,0,1-.616-.213l-4.54-3.555a1,1,0,1,1,1.234-1.574l4.54,3.555a1,1,0,0,1-.618,1.787Z",
  transform: "translate(0 -0.004)",
  fill: "#626a84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.947,31.2A3.722,3.722,0,0,1,5.8,30.519a3.808,3.808,0,0,1-1.579-3.045,7.261,7.261,0,0,0-2.337,2.613,1,1,0,1,1-1.774-.924A8.639,8.639,0,0,1,4.4,25.147c.05-.228.106-.442.165-.634a7.389,7.389,0,0,1,3.821-4.269,1,1,0,0,1,.85,1.811,5.369,5.369,0,0,0-2.605,2.66c1.229-.046,3.287.135,4.2,1.749a3.365,3.365,0,0,1-.3,3.676,1.058,1.058,0,0,1-.131.137A3.719,3.719,0,0,1,7.947,31.2ZM6.2,26.754a2.372,2.372,0,0,0,.721,2.106,1.74,1.74,0,0,0,2.086-.028,1.352,1.352,0,0,0,.071-1.4C8.621,26.623,6.9,26.67,6.2,26.754Z",
  transform: "translate(0 -0.004)",
  fill: "#626a84"
}));

var SvgSideSentHomework = function SvgSideSentHomework(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 36.998 31.194",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideSentHomework, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-sent-homework.61c7b217.svg";
export { ForwardRef as ReactComponent };